// extracted by mini-css-extract-plugin
export default {"grid":"TimeSlotGrid_grid__cjmUr","slot":"TimeSlotGrid_slot__+vzy-","slotSelected":"TimeSlotGrid_slotSelected__WgkjI"};